import { render, staticRenderFns } from "./Voucher.vue?vue&type=template&id=a60ec40e&scoped=true&"
import script from "./Voucher.vue?vue&type=script&lang=js&"
export * from "./Voucher.vue?vue&type=script&lang=js&"
import style0 from "./Voucher.vue?vue&type=style&index=0&id=a60ec40e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a60ec40e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a60ec40e')) {
      api.createRecord('a60ec40e', component.options)
    } else {
      api.reload('a60ec40e', component.options)
    }
    module.hot.accept("./Voucher.vue?vue&type=template&id=a60ec40e&scoped=true&", function () {
      api.rerender('a60ec40e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2DWlbUwBptam5/JS/comp/Voucher.vue"
export default component.exports